export default __webpack_public_path__ + "static/media/_default.97b01e7f.svg";